import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';
import { variablesSelectors } from '@polyai/stream/store/reducers/variables';

const selectVariablesSlice = (state: RootState) => state.variables;

export const selectVariables = createDraftSafeSelector(
  [selectVariablesSlice],
  ({ variables }) => {
    return variablesSelectors.selectAll(variables);
  },
);

export const selectVariableById = createDraftSafeSelector(
  [selectVariablesSlice, (_state: RootState, id: string) => id],
  ({ variables }, id) => {
    return variablesSelectors.selectById(variables, id);
  },
);
